import { BREAKPOINT, TableConfig, TableLayout } from '@spartacus/storefront'
import { EbOrderHistoryTableLinkComponent } from './eb-order-history-table-link.component'
import { EbOrderHistoryTableTranslationComponent } from './eb-order-history-table-translation.component'

export const ebOrderHistoryTableConfig: TableConfig = {
  table: {
    orderHistory: {
      cells: [
        'salesDocNumber',
        'purchaseOrderType',
        'createdAt',
        'purchaseOrderNumber',
        'statusCode',
        'shippingDate',
        'purchasedByName'
      ],
      options: {
        layout: TableLayout.VERTICAL,
        cells: {
          salesDocNumber: {
            dataComponent: EbOrderHistoryTableLinkComponent
          },
          purchaseOrderType: {},
          createdAt: {},
          purchaseOrderNumber: {},
          statusCode: {
            dataComponent: EbOrderHistoryTableTranslationComponent
          },
          shippingDate: {},
          purchasedByName: {}
        }
      },
      [BREAKPOINT.md]: {
        options: { layout: TableLayout.VERTICAL_STACKED }
      },
      [BREAKPOINT.sm]: {
        options: { layout: TableLayout.VERTICAL_STACKED }
      },
      [BREAKPOINT.xs]: {
        options: { layout: TableLayout.VERTICAL_STACKED }
      }
    }
  }
}

export function ebOrderHistoryTableConfigFactory(): TableConfig {
  return ebOrderHistoryTableConfig
}
